import { render, staticRenderFns } from "./AccountsStatusAlertContainer.vue?vue&type=template&id=2d8a892d&scoped=true"
import script from "./AccountsStatusAlertContainer.vue?vue&type=script&lang=js"
export * from "./AccountsStatusAlertContainer.vue?vue&type=script&lang=js"
import style0 from "./AccountsStatusAlertContainer.vue?vue&type=style&index=0&id=2d8a892d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a892d",
  null
  
)

export default component.exports